import { ELoginEvents, ELoginMethods, ELoginMode, EOTPTextModel } from '../Helper/enums';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LoginPage } from './types';
import { StyledImageContainer, StyledLoginPage } from './style';
import { Box, Button } from '@mui/material';
import '../../fonts.css';
import { LoginButtonBlocks } from './LoginButtonsBlock/LoginButtonBlocks';
import './styles.scss';
import { LoginTermsBlock } from './LoginTermsBlock/LoginTermsBlock';
import { ProductMadnessLogin } from './CustomTemplates/ProductMadness/ProductMadnessLogin';
import { useState } from 'react';
import { isWebviewBrowser as checkIfWebview } from '../../utils';
import { WebviewEscapeScreen } from './WebviewEscapeScreen/WebviewEscapeScreen';
import { isDesktop } from 'react-device-detect';

// ACDEV-8185: moved to store
export const Login: React.FC<LoginPage> = (props) => {
  const {
    isMobilePreview,
    textSize = 24,
    textColor = 'blue',
    textWeight = 'normal',
    text = 'Welcome to appcharge store!',
    logo = 'https://media.appcharge.com/defaults/logo.svg',
    loginLogoSize,
    playerAuthData,
    width = '100vw',
    height = '100vh - 200px',
    backgroundColor = 'transparent',
    fontFamily,
    onContactSupport = undefined,
    flex,
    trackLoginEvent,
    setMode,
    mode,
    gameName,
    openInfoModal,
    privacyPolicyLink,
    termsAndConditionsLink,
    sendEventCallback,
    openLinksInNewTab = false,
    translations = {
      signInWithFacebook: 'Sign in with Facebook',
      signInWithGoogle: 'Sign in with Google',
      signInWithApple: 'Sign in with Apple',
      loginWithPlayerId: 'Login with Player ID',
      userName: 'Username',
      password: 'Password',
      login: 'Login',
      contactSupport: 'Contact support',
      privacyPolicy: 'Privacy Policy',
      termsAndConditions: 'Terms and Conditions',
      byLoggingIn:
        'By logging in you acknowledge that you have read and agree to the',
      and: 'And',
      back: 'Back',
      playerId: 'Player ID',
      leavingWebviewTitle: 'Leaving',
      leavingWebviewDescription:
        'Open this link in external browser to use your preferred login method',
      leavingWebviewButton: 'Open in an external browser',
      or: 'Or',
    },
  } = props;

  const [isWebview, _] = useState(checkIfWebview());

  const showOtpButton =
    playerAuthData.otpOn &&
    (isDesktop
      ? playerAuthData?.otpTextModel &&
        playerAuthData?.otpTextModel !== EOTPTextModel.MOBILE_ONLY
      : true);

  const handleBackBtnClicked = async () => {
    setMode(ELoginMode.PROVIDERS);
    let method;

    switch (mode) {
      case ELoginMode.TOKEN_ID:
        method = ELoginMethods.TOKEN;
        break;
      case ELoginMode.USERNAME:
        method = ELoginMethods.USERNAME;
        break;
      case ELoginMode.OTP:
        method = ELoginMethods.OTP;
        break;
      default:
        method = undefined;
    }
    if (method && trackLoginEvent) {
      await trackLoginEvent(ELoginEvents.LOGIN_CANCELED, method);
    }
  };

  const isProductMadness = ['jackpot-slots', 'big-fish-casino'].includes(
    gameName || '',
  );

  return (
    <GoogleOAuthProvider clientId={playerAuthData?.googleAppId || ''}>
      {isProductMadness ? (
        <ProductMadnessLogin
          loginProps={props}
          handleBackBtnClicked={handleBackBtnClicked}
          showWebviewEscapeScreen={isWebview}
          gameName={gameName}
        />
      ) : (
        <StyledLoginPage
          fontFamily={fontFamily}
          textColor={textColor}
          textSize={textSize}
          textWeight={textWeight}
          width={width}
          height={height}
          backgroundColor={backgroundColor}
          flex={flex}
        >
          <StyledImageContainer isMobilePreview={isMobilePreview}>
            <img
              className="logo"
              id={loginLogoSize}
              alt="game logo"
              src={logo}
              style={{
                width: window.location.hostname.includes('matchmaste.rs')
                  ? '230px'
                  : 'auto',
              }}
            />
          </StyledImageContainer>
          {isWebview && mode === ELoginMode.PROVIDERS ? (
            <>
              <WebviewEscapeScreen
                translations={translations}
                textColor={textColor}
                sendEventCallback={sendEventCallback}
              />
              {showOtpButton && <div className="orText">{translations.or}</div>}
            </>
          ) : (
            <h2>{text}</h2>
          )}
          <LoginButtonBlocks {...props} isWebview={isWebview} />
          {(!isWebview || playerAuthData.otpOn) && (
            <LoginTermsBlock
              textColor={textColor}
              openInfoModal={openInfoModal}
              privacyPolicyLink={privacyPolicyLink}
              termsAndConditionsLink={termsAndConditionsLink}
              translations={translations}
              openInNewTab={openLinksInNewTab}
            ></LoginTermsBlock>
          )}
          {!isWebview && (
            <ContactSupport
              onContactSupport={onContactSupport}
              text={translations.contactSupport}
            />
          )}
          {mode !== ELoginMode.PROVIDERS && (
            <button className="backButton" onClick={handleBackBtnClicked}>
              {translations.back}
            </button>
          )}
        </StyledLoginPage>
      )}
    </GoogleOAuthProvider>
  );
};

const ContactSupport: React.FC<{
  onContactSupport?: () => void;
  text: string;
}> = ({ onContactSupport, text }) => (
  <Box mt={2}>
    <Button
      variant="text"
      sx={{
        color: 'white',
        textTransform: 'none',
        fontSize: '16px',
      }}
      onClick={() => onContactSupport?.()}
    >
      {text}
    </Button>
  </Box>
);
